import { useState, useRef, useEffect } from "react";
import "./EditableTable.css";
import { api } from '../../../services/services';
import Autocomplete from "../Autocomplete/Autocomplete";
import Card from "../Card/Card";
import MultiSelectAutocomplete from "../../MyUI/MultiSelectAutocomplete/MultiSelectAutocomplete";

export default function EditableTable({ title, columns, params, setParams, validateRows, addRows =true, defaultValues = {} }) {
  const [active, setActive] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  const [imageUrl, _setImageUrl] = useState("");
  
  const setImageUrl = (relativeUrl) => {
    _setImageUrl(getFullImageUrl(relativeUrl));
  }; 
  
  const getFullImageUrl = (relativeUrl) => {
  if (!relativeUrl) return "";

  const mediaBaseUrl = api.defaults.baseURL.replace("/api", "");
  return `${mediaBaseUrl.replace(/\/$/, "")}/${relativeUrl.replace(/^\//, "")}`;
  };

  const toggleCard = () => {
    setCollapsed((prev) => !prev);
  };
  const editRef = useRef(null);

  const update = (row, key, value) => {
    const copy = [...params];
    copy[row][key] = value;
    setParams(copy);
  };

  // Click outside & Enter key to close editing
useEffect(() => {
  const handleKeyDown = (e) => {
    if (!active) return;

    const [row, key] = active.split("-");
    const rowIndex = Number(row);
    const colIndex = columns.findIndex(c => c.key === key);


    if (e.key === "Tab") {
      e.preventDefault();
      moveFocus(rowIndex, colIndex, e.shiftKey ? "prev" : "next");
    }

    if (e.key === "Enter") {
      setActive(null);
    }

    if (e.key === "Escape") {
      setActive(null);
    }
  };
  const handleClickOutside = (e) => {
      if (editRef.current && !editRef.current.contains(e.target)) {
        setActive(null);
      }
    };
  document.addEventListener("click", handleClickOutside);
  document.addEventListener("keydown", handleKeyDown);
  return () => {
    
    document.removeEventListener("click", handleClickOutside);
    document.removeEventListener("keydown", handleKeyDown);};
}, [active]);


  const moveFocus = (rowIndex, colIndex, direction) => {
  const rows = params.length;
  const cols = columns.length;

  let nextRow = rowIndex;
  let nextCol = colIndex;

  if (direction === "next") {
    nextCol++;
    if (nextCol >= cols) {
      nextCol = 0;
      nextRow++;
    }
  } else {
    nextCol--;
    if (nextCol < 0) {
      nextCol = cols - 1;
      nextRow--;
    }
  }

  if (nextRow < 0 || nextRow >= rows) {
    setActive(null);
    return;
  }

  setActive(`${nextRow}-${columns[nextCol].key}`);
};

const addRow = () => {
    setParams([
      ...params,
      { second_id: params.length + 1, ...defaultValues },
    ]);
  };

  const removeRow = (index) => {
    const updated = params.filter((_, i) => i !== index);
    updated.forEach((row, i) => (row.second_id = i + 1));
    setParams(updated);
    setActive(null);
  };

const getCellErrorFromValidateRows = (row, col) => {
  // We can reuse validateRows by passing a single-row array
  const { invalidFields } = validateRows([row], [col]);
  if (invalidFields.length > 0) {
    return invalidFields[0].message;
  }
  return null;
};


  return (
    <Card title={title} collapsed={collapsed} toggleCard={toggleCard}>
      
        {addRows && (
        <div style={{ width: "100%", textAlign: "right", marginBottom: "10px" }}>
          <button className="default-btn primary" onClick={addRow}>
            Add Row
          </button>
        </div>
      )}

        <table className="data-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {params.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col) => {
                  const isEditing = active === `${rowIndex}-${col.key}`;
                  const errorMessage = getCellErrorFromValidateRows(row, col);
                  return (
                    <td key={col.key} 
                    ref={isEditing ? editRef : null}
                    onClick={() => {
                      if (col.type !== "readonly" && col.type !== "readonly2") {
                        setActive(`${rowIndex}-${col.key}`)
                        }
                      }}>
                      {isEditing ? (
                        col.type === "profile_picture" ? (
                          <div className="center">
                            <img
                              src={imageUrl}
                              alt="Profile"
                              style={{
                                width: 220,
                                height: 220,
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        
                        ) : col.type === "Autocomplete" ? (
                          <Autocomplete
                            options={col.Autocomplete}
                            value={row[col.key]}
                            placeholder={col.placeholder}
                            autoFocus
                            onChange={(val) => {
                              update(rowIndex, col.key, val);
                              setActive(null);
                            }}
                          />
                        ): col.type === "MultiSelectAutocomplete" ? (
                          <MultiSelectAutocomplete
                            options={col.combboxElements}
                            value={row[col.key]}
                            placeholder={col.placeholder}
                            autoFocus
                            onChange={(val) => {
                              update(rowIndex, col.key, val);
                              setActive(null);
                            }}
                          />
                        ):col.type === "select" ? (
                          <Autocomplete
                            mode="select"
                            value={row[col.key]}
                            onChange={(val) => update(rowIndex, col.key, val)}
                            placeholder="Select..."
                            options={Object.entries(col.SELECT_OPTIONS).map(([key, label]) => ({
                              label,
                              value: key,
                            }))}
                          />

                        ) : (
                        <>                            
                          <input className="MyInput"
                            value={row[col.key] || ""}
                            placeholder={col.placeholder}
                            autoFocus
                            onChange={(e) => update(rowIndex, col.key, e.target.value)}
                          />
                        </>
                        )
                      ) :col.type == "readonly" ? (
                          <>
                          {row[col.key] || (Number(row.Likelihood_for_Triangle) || 0) * (Number(row.Severity_for_Triangle) || 0)}
                          </>
                        ):col.type == "readonly2" ? (
                          <>
                          {row[col.key] || (Number(row.Likelihood_for_2L) || 0) * (Number(row.Severity_for_2L) || 0)}
                          </>                          
                        ) :(
                          <>
                          {row[col.key] || "-"}
                          {errorMessage && (
                            <div style={{ color: '#ff5252', fontSize: '0.75rem', marginTop: '2px' }}>
                              {errorMessage}
                            </div>
                          )}
                          </>
                      )}
                    </td>
                  );
                })}
                {/* Actions column */}
                {addRows && (
                  <td>
                    <button style={{ color: "red" }} onClick={() => removeRow(rowIndex)}>
                      Delete
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
    </Card>
  );
}
